'use client';

import { usePathname } from 'next/navigation';

import { Link } from '@/components/Link/Link';

import { Item } from '../Item/Item';

import styles from './LinkItem.module.scss';

interface Props {
    className?: string;
    title?: string;
    href: string;
    children?: string;
}

export function LinkItem({ children, className, href, title }: Props) {
    const pathname = usePathname();
    const isActive = pathname?.startsWith(href);

    return (
        <Item className={className} isActive={isActive}>
            <Link href={href} className={styles.linkItem} title={title}>
                {children}
            </Link>
        </Item>
    );
}
